import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { ModalName } from "src/app/enums/modal-name";
import { IResetPasswordPayload } from "src/app/models/auth/reset-password-payload";
import { AuthService } from "src/app/services/auth.service";
import { ModalService } from "src/app/services/modal.service";

const DEFAULT_ERROR_MESSAGE = "Something went wrong, please try again";
const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,30}$/;

@Component({
  selector: "app-password-reset",
  templateUrl: "./password-reset.component.html",
  styleUrls: ["./password-reset.component.scss"],
})
export class PasswordResetComponent implements OnInit {
  readonly passwordErrorMessage =
    "'Password' must be between 8 and 30 characters where at least one upper case, one lower case letters and one special symbol";

  form: UntypedFormGroup;
  isPasswordVisible = false;
  isRepeatPasswordVisible = false;
  isResetError = false;
  isLinkInvalid = false;
  resetErrorMessage = DEFAULT_ERROR_MESSAGE;

  private _token = "";
  private _email = "";

  constructor(
    private readonly _authService: AuthService,
    private readonly _modalService: ModalService,
    private readonly _router: Router,
    private readonly _route: ActivatedRoute
  ) {}

  togglePasswordVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  toggleRepeatPasswordVisibility() {
    this.isRepeatPasswordVisible = !this.isRepeatPasswordVisible;
  }

  resetPassword() {
    this.isResetError = false;

    const payload: IResetPasswordPayload = {
      email: this._email,
      token: this._token,
      newPassword: this.form.get("newPassword").value,
    };

    this._authService.resetPassword(payload).subscribe({
      next: () => this._modalService.openModal(ModalName.Success),
      error: (error: HttpErrorResponse) => this.showResetError(error),
    });
  }

  navigateToAuth() {
    this._router.navigate(["/auth"]);
  }

  private showResetError(error: HttpErrorResponse) {
    this.resetErrorMessage = error?.error?.errors?.[0] ?? DEFAULT_ERROR_MESSAGE;
    this.isResetError = true;
  }

  private static passwordsMatchValidator(control: AbstractControl): ValidationErrors | null {
    const newPassword = control.get("newPassword")?.value;
    const repeatPassword = control.get("repeatPassword")?.value;

    return newPassword === repeatPassword ? null : { passwordsMismatch: true };
  }

  ngOnInit(): void {
    this._token = this._route.snapshot.queryParamMap.get("token") ?? "";
    this._email = this._route.snapshot.queryParamMap.get("email") ?? "";
    this.isLinkInvalid = !this._token || !this._email;

    this.form = new UntypedFormGroup(
      {
        newPassword: new UntypedFormControl("", [Validators.required, Validators.pattern(PASSWORD_PATTERN)]),
        repeatPassword: new UntypedFormControl("", [Validators.required, Validators.minLength(8)]),
      },
      { validators: PasswordResetComponent.passwordsMatchValidator }
    );
  }
}
